import { render } from "./VenueDetail.vue?vue&type=template&id=af038c5c&scoped=true"
import script from "./VenueDetail.vue?vue&type=script&lang=js"
export * from "./VenueDetail.vue?vue&type=script&lang=js"

import "./VenueDetail.vue?vue&type=style&index=0&id=af038c5c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af038c5c"]])

export default __exports__